import { RequestContext } from '../../types/request-context';
import { DVString, Link } from './shared';

export interface CodeBasedLinkingInput {
    context: RequestContext;
    ubid?: string;
    authenticationToken?: string;
    publicCode?: string;
    token?: string;
}

export interface CodeBasedLinkingOutput {
    isSuccess: boolean;
    content: CodeBasedLinkingLandingPage | CodeBasedLinkingResponsePage;
    messages: CodeBasedLinkingDisplayMessage[];
    token?: string;
}

export interface CodeBasedLinkingContent {
    __type: string;
}

export interface CodeBasedLinkingLandingPage extends CodeBasedLinkingContent {
    heading: string;
    title: string;
    intro: string;
    codeLabel: string;
    codePlaceholder: string;
    buttonText: string;
    termsText: DVString;
    helpTitle: string;
    invalidCodeText: string;
    steps: CodeBasedLinkingStep[];
}

export interface CodeBasedLinkingStep {
    title: string;
    content: string;
}

export interface CodeBasedLinkingResponsePage extends CodeBasedLinkingContent {
    settingsTitle: string;
    devicesButton: Link;
    parentalControlsButton: Link;
    paymentSettingsButton: Link;
    showMerchandiserSlot: boolean;
}

export interface CodeBasedLinkingDisplayMessage {
    severity: CodeBasedLinkingDisplayMessageSeverity;
    title: string;
    content?: DVString;
}

export enum CodeBasedLinkingDisplayMessageSeverity {
    Success = 'Success',
    Warning = 'Warning',
    Error = 'Error',
}
